import { createBrowserRouter } from "react-router-dom";
import { AuthRouter } from "../components/AuthRouter";
import { lazy, Suspense } from "react";
import App from "../App";
import Login from "../pages/Login";
import {history} from '../utils/history';


// import GridPage from "../pages/GridPage";
// import UnitPage from "../pages/UnitPage";
// import OrderRecord from "../pages/OrderRecord";
// import OpenHistory from "../pages/OpenHistory";
// import UserCenter from "../pages/RoleManage/UserCenter";
// import UserManage from "../pages/RoleManage/UserManage";
// import AreaManage  from "../pages/AreaManage";
// import RequestLog  from "../pages/SystemLog/RequestLog";
// import LoginLog  from "../pages/SystemLog/LoginLog";

const UnitPage=lazy(()=>import("../pages/UnitPage"))
const GridPage=lazy(()=>import("../pages/GridPage"))
const OrderRecord=lazy(()=>import("../pages/OrderRecord"))
const OpenHistory =lazy(()=>import("../pages/OpenHistory"))
const UserCenter=lazy(()=>import("../pages/RoleManage/UserCenter"))
const UserManage=lazy(()=>import("../pages/RoleManage/UserManage"))
const AreaManage=lazy(()=>import("../pages/AreaManage"))
const RequestLog=lazy(()=>import("../pages/SystemLog/RequestLog"))
const LoginLog=lazy(()=>import("../pages/SystemLog/LoginLog"))

const baseRouter = createBrowserRouter([
  // 一级路由
  {
    path: "/",
    element: (
      <AuthRouter>
        <App />
      </AuthRouter>
    ),
    children: [
      // 二级路由
      {
        index: true,
        element: <Suspense fallback={'加载中'}><UnitPage /></Suspense>,
        label: "首页",
      },
      {
        path: "unitPage",
        element: <Suspense fallback={'加载中'}><UnitPage /></Suspense>,
        label: "设备管理"
      },
      {
        path: "unitPage/gridPage",
        element: <Suspense fallback={'加载中'}><GridPage /></Suspense>,
        label: "箱柜管理",
      },
      {
        path: "roleManage",
        children: [
          {
            index: true,
            element: <Suspense fallback={'加载中'}><UserManage /></Suspense>,
            label: "用户管理",
          },
          {
            path: "userManage",
            element: <Suspense fallback={'加载中'}><UserManage /></Suspense>,
            label: "用户管理",
          },
          {
            path: "userCenter",
            element: <Suspense fallback={'加载中'}><UserCenter /></Suspense>,
            label: "个人中心",
          },
        ],
        label: "权限管理",
      },
      {
        path: "orderRecord",
        element: <Suspense fallback={'加载中'}><OrderRecord /></Suspense>,
        label: "订单记录",
      },
      {
        path: "openHistory",
        element: <Suspense fallback={'加载中'}><OpenHistory /></Suspense>,
        label: "操作记录",
      },
      {
        path: "areaManage",
        element: <Suspense fallback={'加载中'}><AreaManage /></Suspense>,
        label: "区域管理",
      },
      {
        path: "systemLog",
        children: [
          // 二级路由
          {
            index: true,
            element: <Suspense fallback={'加载中'}><LoginLog /></Suspense>,
            label: "登录日志",
          },
          {
            path: "loginLog",
            element: <Suspense fallback={'加载中'}><LoginLog /></Suspense>,
            label: "登录日志",
          },
          {
            path: "requestLog",
            element: <Suspense fallback={'加载中'}><RequestLog /></Suspense>,
            label: "请求日志",
          },
        ],
        label: "系统日志",
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
    index: true,
    label: "登录页面",
  },
],{history});

export default baseRouter;
